export const UPLOAD_STATUS_CD = {
    /** 업로드 진행중 */
    IN_PROGRESS: "1",

    /** 업로드 완료 */
    UPLOAD_COMPLETED: "2",

    /** 업로드 삭제 */
    UPLOAD_DELETED: "3",
} as const;

export type UploadStatusCd_Type = typeof UPLOAD_STATUS_CD[keyof typeof UPLOAD_STATUS_CD];

export const FILE_USAGE_CD = {
    /** 촬영원본사진 */
    ORIGINAL_PHOTO: "1",

    /** 고객선택사진 */
    CUSTOMER_SELECTED_PHOTO: "2",

    /** 후기이벤트사진 */
    REVIEW_EVENT_PHOTO: "3",

    /** 촬영편집사진 */
    EDITED_PHOTO: "4",

    /** 상세상품대표이미지 */
    PRODUCT_DETAIL_MAIN: "5",

    /** 상품옵션이미지 */
    PRODUCT_OPTION: "6",

    /** 촬영상품테마이미지 */
    THEME_PHOTO: "7",

    /** 직원서명 */
    STAFF_SIGNATURE: "8",

    /** MMS이미지 */
    MMS_IMAGE: "9",

    /** 계약서 */
    CONTRACT: "10",

    /** 상사상품폴더정보 */
    PRODUCT_FOLDER: "11",

    /** 테마북상세페이지 이미지 */
    THEME_BOOK_DETAIL_PAGE_IMAGE: "13",
} as const;

/**
1	촬영원본사진
2	고객선택사진
3	후기이벤트사진
4	촬영편집사진
5	상세상품대표이미지
6	상품옵션이미지
7	촬영상품테마이미지
8	직원서명
9	MMS이미지
10	계약서
 */
export type FileUsageCd_Type = typeof FILE_USAGE_CD[keyof typeof FILE_USAGE_CD];

interface UploadFileDetailData_Type {
    row_num: number;

    /** 파일 상세 pk */
    upload_file_detail_pk: number;

    /** 파일 pk */
    upload_file_pk: number;

    /** 하위 경로 */
    sub_path: string;

    /** 파일 명 */
    file_nm: string;

    /** 파일 확장자 */
    file_ext: string;

    /** 파일 크기 */
    file_size: number;

    /** 폴더ID */
    folder_id: string;

    /** 파일 상태 코드 */
    upload_status_cd: string;

    /** 파일 상대 경로 */
    upload_rela_url: string;

    /** 삭제 pk */
    delete_pk: number;

    /** 업로드 호스팅 코드 */
    hosting_cd: string;

    /** 업로드 호스팅 명 */
    hosting_name: string;

    /** 중간사이즈 썸네일 프리사인 url */
    middle_img: string;

    /** 작은사이즈 썸네일 프리사인 url */
    small_img: string;

    /** 원본 이미지 url */
    org_img: string;
}

interface ProductItemPhotoData_Type {
    /** 순번 */
    row_num: number;

    /** 업로드파일PK */
    upload_file_pk: number;

    /** 데이터PK */
    data_pk: number; // 데이터PK

    /** 파일용도코드 */
    file_usage_cd: string;

    /** 파일용도코드명 */
    file_usage_name: string;

    /** 업로드상대url */
    upload_rela_url: string;

    /** 업로드 된 이미지 count */
    upload_count: number;

    /** 업로드 호스팅 코드 */
    hosting_cd: string;

    /** 업로드 호스팅 명 */
    hosting_name: string;

    /** 브랜드ID */
    brand_id: number;

    /** 브랜드명 */
    brand_name: string;

    /** 그룹ID */
    group_id: number;

    /** 그룹명 */
    group_name: string;

    /** 지점ID */
    office_id: number;

    /** 지점명 */
    office_name: string;

    /** 직원ID */
    staff_id: number;

    /** 직원명 */
    staff_name: string;

    upload_file_detail_data: UploadFileDetailData_Type[];

    /** 업로드 파일 크기 (byte) */
    upload_file_size: number;

    /** 업로드 일시 (yyyyMMddHHmmss) */
    upload_file_ts: string;

    /** 원본 이미지 삭제 일시 (해당 값이 존재할경우 다운로드가 불가능함) */
    org_delete_dtm: string;
}

export interface ProductItemPhoto_Type {
    data: ProductItemPhotoData_Type[];
    limit_count: number;
    limit_start: number;
    total_count: number;
}